import React from 'react';
import PricesContainer from './styles';
import { prices } from '../../../../utils';
import PriceCard from './../../../../components/Cards/Price';
import { useTranslation } from 'react-i18next';
import { Typography, Grid } from '@material-ui/core';

const Prices = () => {
	const { t, i18n } = useTranslation();
	const getPricesCard = () => {
		return prices[i18n.language].map((data, idx) => (
			<Grid item xs={12} sm={6} md={4} key={idx}>
				<PriceCard
					tag={t(data.tag)}
					tagColor={t(data.tagColor)}
					label={t(data.label)}
					title={t(data.title)}
					subtitle={t(data.subtitle)}
					information={data.information}
					price={data.price}
					image={data.image}
					imageOff={data.imageOff}
					labelWhite={data.labelWhite}
					discount={data.discount}
					disabled={data.buttonDisabled}
				/>
			</Grid>
		));
	};
	return (
		<PricesContainer>
			<div className="prices__data">
				<Typography variant={'h2'}>{t('general.inscriptions.section')}</Typography>
			</div>
			<Grid container className="prices__list" justify="center">
				{getPricesCard()}
			</Grid>
		</PricesContainer>
	);
};

export default Prices;
